import { useMutation } from '@tanstack/react-query'
import { sendTransactionExportToEmail } from 'services/TransactionService'

export const useSendWalletTransactionsToEmailMutation = () =>
  useMutation({ mutationFn: sendTransactionExportToEmail })
